import { render, staticRenderFns } from "./Apports.vue?vue&type=template&id=40bfb5bf"
import script from "./Apports.vue?vue&type=script&lang=js"
export * from "./Apports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports